// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_12-1";
export var movingGradient = "_12-4";
export var movingGradientBlock = "_12-2";
export var skeleton = "_12-0";
export var skeletonText = "_12-3";